export default {
  paged: {
    select:
      'id,processName,title,number,created,favorite,importance,type,processInstanceId,status,creatorType,overdueDateTime,plannedDateTime,reminderDateTime,notes,applicant',
    notSelectSearch: 'relatedUserTasks,commands',
    searchSelect: ['title', 'number'],
    expand: {
      relatedUserTasks: { select: 'userId,userFullName,taskStatus' },
      commands: { select: '' },
    },
  },
};
